import {ReactNode, useState} from "react";
import {ChevronDown, ChevronRight, CircleAlert} from "lucide-react";
import {cn} from "@/lib/utils.ts";

export default function CollapsibleFormSection({title, summary, children, forceOpen = false, className,
                                                   contentClassName}: {
    title: string;
    summary: ReactNode;
    children: ReactNode;
    forceOpen?: boolean;
    className?: string;
    contentClassName?: string;
}) {
    const [expanded, setExpanded] = useState(false);
    const open = expanded || forceOpen;

    return <section className={cn("space-y-3", className)}>
        <button type="button" className="flex w-full items-center gap-2 border-b pb-3 text-left"
                onClick={() => setExpanded(value => !value)} aria-expanded={open}>
            {open ? <ChevronDown className="size-4"/> : <ChevronRight className="size-4"/>}
            <span className="font-semibold">{title}</span>
            <span className="text-sm text-muted-foreground">{summary}</span>
            {forceOpen && <CircleAlert className="ml-auto size-4 text-destructive" aria-label="Enthält Fehler"/>}
        </button>
        {open && <div className={contentClassName}>{children}</div>}
    </section>;
}
